module.exports = __webpack_public_path__ + "static/media/ig.70332335.svg";